import Vue from 'vue'
import Router from 'vue-router'
import Booking from '../views/Booking'
import FindBooking from '../views/FindBooking'
import Confirmation from '../views/Confirmation'
import Appointment from '../views/Appointment'
import RescheduleAppointment from '../views/RescheduleAppointment'
import ErrorPage from '../views/ErrorPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'booking',
      component: Booking,
      props: true
    },
    {
      path: '/search',
      name: 'search',
      component: FindBooking
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: Confirmation,
      props: true
    },
    {
      path: '/preselect/branch/:branchId/services/:serviceId',
      alias: '/service=:serviceId&branch=:branchId',
      name: 'calendarbooking',
      component: Booking,
      props: true
    },
    {
      path: '/preselect/branch/:branchId',
      alias: '/branch=:branchId',
      name: 'branchbooking',
      component: Booking,
      props: true
    },
    {
      path: '/preselect/branch/:branchId/servicegroups/:serviceGroups',
      name: 'branchandservicegroupsbooking',
      component: Booking,
      props: true
    },
    {
      path: '/preselect/services/:serviceId',
      alias: '/service=:serviceId',
      name: 'servicebooking',
      component: Booking,
      props: true
    },
    {
      path: '/preselect/servicegroups/:serviceGroups',
      name: 'servicegroupsbooking',
      component: Booking,
      props: true
    },
    {
      path: '/:appointmentId',
      name: 'appointment',
      component: Appointment
    },
    {
      path: '/:appointmentId/reschedule',
      name: 'reschedule',
      component: RescheduleAppointment,
      props: true
    },
    {
      path: '*',
      name: '404',
      component: ErrorPage
    }
  ]
})
